import { API } from "@/lib/api";
import { toast } from "sonner";

/**
 * Authenticated PDF download.
 * Fetches the PDF via `fetch` with the current bearer token, converts the
 * blob to a temporary object URL, and triggers a browser download.
 */
export async function downloadInvoicePdf({ path, filename }) {
  try {
    const token = localStorage.getItem("island_token");
    const res = await fetch(`${API}${path}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error(`Invoice download failed (${res.status})`);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success("Invoice downloaded.");
  } catch (err) {
    toast.error(err.message || "Could not download invoice.");
  }
}
